import data from './manual-rv-data.json.js';

/** manually duplicated RvData from UK2 apartments that is used in UK1 for backwards compatibility reasons. */
const ManualRvData = data;

export { ManualRvData };
//# sourceMappingURL=manual-rv-data.js.map
